import { useTahun } from "@/hooks/useTahun";
import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";

const listMenu = [
  {
    name: "Users Elearning",
    path: "/operator-pasca/users-elearning",
  },
  {
    name: "Group Elearning",
    path: "/operator-pasca/groups-elearning",
  },
  {
    name: "Nilai Elearning",
    path: "/operator-pasca/nilai-elearning",
  },
];

const getListUserElearning = async (
  page: string,
  limit: string,
  searchQuery: string,
  tahun: string,
) => {
  const params = new URLSearchParams();
  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (searchQuery) params.append("search", searchQuery);
  if (tahun) params.append("tahun", tahun);

  const response = await api.get(
    `/operator-pasca/user-elearning/index?${params.toString()}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export default function UsersElearningPage() {
  const [searchParams] = useSearchParams();
  const pageParams = searchParams.get("page") || 1;
  const limitParams = searchParams.get("limit");
  const searchQueryParams = searchParams.get("search");
  const { pathname } = useLocation();

  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: [
      "listUserElearning",
      pageParams,
      limitParams,
      searchQueryParams,
      selectedTahun?.label,
    ],
    queryFn: () =>
      getListUserElearning(
        pageParams as string,
        limitParams as string,
        searchQueryParams as string,
        selectedTahun?.label,
      ),
  });

  return (
    <div>
      <div className="rounded-full border overflow-hidden flex w-fit">
        {listMenu.map((menu, index) => {
          const active = menu.path === pathname;
          return (
            <Link
              key={index}
              to={menu.path}
              className={`py-2 px-3  ${
                active
                  ? `bg-black text-white ${
                      index === 0
                        ? "rounded-r-full"
                        : index === listMenu.length
                          ? "rounded-l-full"
                          : "rounded-full"
                    }`
                  : "hover:bg-secondary cursor-pointer"
              }`}
            >
              <span className="font-semibold text-sm">{menu.name}</span>
            </Link>
          );
        })}
      </div>

      <DataTable
        data={data?.data || []}
        paginationData={data}
        columns={columns}
        isPending={isPending}
      />
    </div>
  );
}
